module.exports = __webpack_public_path__ + "OpenSans-ExtraBold.12e2ed7a180e601bff44.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.woff
// module id = ../../../../npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.woff
// module chunks = styles